import React, { useCallback, useState } from 'react';

import { Drawer, IconButton, useTheme } from '@mui/material';

import { useConfigs } from 'modules/configs';
import BookDemoButton from 'pages/Landings/components/BookDemoButton';
import PageBottom from 'pages/Landings/components/PageBottom';
import SiteNavigation from 'pages/Landings/components/SiteNavigation';
import StartTrialButton from 'pages/Landings/components/StartTrialButton';
import SupportButton from 'pages/Landings/components/SupportButton';
import { isLightMode } from 'pages/Landings/utils';

import IconClose from './assets/close.svg';
import IconMenu from './assets/menu.svg';
import useStyles from './styles';

interface Props {
    container: () => HTMLElement;
    scroller: React.ForwardedRef<HTMLDivElement>;
    className?: string;
}

const DrawerMenu: React.FC<Props> = ({ container, scroller, className }) => {
    const { classes, cx } = useStyles();
    const { entrypoint } = useConfigs();
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => setIsOpen((state) => !state), []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <>
            <IconButton disableFocusRipple centerRipple onClick={toggle} className={cx(classes.root, className)}>
                {isOpen ? <IconClose /> : <IconMenu />}
            </IconButton>
            <Drawer
                anchor="left"
                ModalProps={{ container, keepMounted: false, disableScrollLock: true }}
                PaperProps={{
                    className: classes.paper,
                    ref: scroller
                }}
                open={isOpen}
                onClose={close}
            >
                <SiteNavigation className={classes.navigation} />
                <PageBottom />
                <div className={classes.buttons}>
                    {entrypoint === 'main' && (
                        <BookDemoButton shadows={false} color={isLightMode(theme) ? 'black' : 'white'} fullWidth />
                    )}
                    {entrypoint === 'main' && <StartTrialButton fullWidth />}
                    {entrypoint === 'docs' && (
                        <SupportButton color={isLightMode(theme) ? 'black' : 'white'} fullWidth />
                    )}
                </div>
            </Drawer>
        </>
    );
};

export default DrawerMenu;
